var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn_box",on:{"click":function($event){return _vm.handleClick(_vm.item)}}},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.item.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }